import {
  PRODUCTINVENTORYBRANCH_LOADING,
  GET_PRODUCTINVENTORYBRANCH,
  GET_PRODUCTINVENTORYBRANCH_SUCCESS,
  GET_PRODUCTINVENTORYBRANCH_FAIL,
  ADD_PRODUCTINVENTORYBRANCH_SUCCESS,
  ADD_PRODUCTINVENTORYBRANCH_FAIL,
  DELETE_PRODUCTINVENTORYBRANCH_SUCCESS,
  DELETE_PRODUCTINVENTORYBRANCH_FAIL,
  UPDATE_PRODUCTINVENTORYBRANCH_SUCCESS,
  UPDATE_PRODUCTINVENTORYBRANCH_FAIL,
  PRODUCTINVENTORYBRANCH_RESET
} from "./actionType";

const INIT_STATE = {
  productInventoryBranches: [],
  error: {},
};

const ProductInventoryBranch = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTINVENTORYBRANCH_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTINVENTORYBRANCH:
          return {
            ...state,
            productInventoryBranches: action.payload.data,
            isProductInventoryBranchCreated: false,
            isProductInventoryBranchSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTINVENTORYBRANCH_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTINVENTORYBRANCH_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductInventoryBranchCreated: false,
            isProductInventoryBranchSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTINVENTORYBRANCH: {
      return {
        ...state,
        isProductInventoryBranchCreated: false,
        loading: true,
      };
    }

    case PRODUCTINVENTORYBRANCH_LOADING: {
      return {
        ...state,
        isProductInventoryBranchCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTINVENTORYBRANCH_SUCCESS:
      return {
        ...state,
        isProductInventoryBranchCreated: true,
        loading: false,
        productInventoryBranches: [action.payload.data, ...state.productInventoryBranches],
      };

    case ADD_PRODUCTINVENTORYBRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTINVENTORYBRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductInventoryBranchCreated: true,
        productInventoryBranches: state.productInventoryBranches.filter(
          productInventoryBranch => productInventoryBranch.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTINVENTORYBRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTINVENTORYBRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductInventoryBranchCreated: true,
        productInventoryBranches: state.productInventoryBranches.map(productInventoryBranch =>
          productInventoryBranch.id.toString() === action.payload.data.id.toString() ? { ...productInventoryBranch, ...action.payload.data } : productInventoryBranch
        ),
      };

    case UPDATE_PRODUCTINVENTORYBRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTINVENTORYBRANCH_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductInventoryBranch;